<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページは{{
            detail.links.join('、')
          }}のページへURLが正規化されています。
        </p>
        <template v-else>
          <p v-if="!detail.hasCanonical">
            canonicalタグが設定されていません。
          </p>
          <p v-if="!detail.isNotDuplicate">
            canonicalタグが2つ以上設定されています。
          </p>
          <p v-if="!detail.isCorrectDomain">
            canonicalに設定されているURLのホスト名が評価対象URLのホスト名と一致しない、もしくはURLが正規化されていないページです。
          </p>
        </template>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          Webページが以下のような場合は、canonicalタグの設置を使用してください。
        </p>
        <dl>
          <dt>canonicalタグを設置したほうがいい例</dt>
          <dd>
            <ul class="c-list--disc">
              <li>ユーザーがアクセスするページが重複している</li>
              <li>
                ファイルサイズやレイアウト上のCSSなどで異なるURLが存在し、サイズやCSS以外の内容が重複している
              </li>
              <li>
                PCサイト、スマホサイト、モバイルサイトの関係性をクローラーに指示する場合
              </li>
              <li>
                301リダイレクトの設定がサーバー上で設定できず、URLの正規化を行う必要がある
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
